import { render, staticRenderFns } from "./HippaForm.vue?vue&type=template&id=13b2e9c8&scoped=true"
import script from "./HippaForm.vue?vue&type=script&lang=js"
export * from "./HippaForm.vue?vue&type=script&lang=js"
import style0 from "./HippaForm.vue?vue&type=style&index=0&id=13b2e9c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b2e9c8",
  null
  
)

export default component.exports